import React from "react";
import "./header.scss";

class Header extends React.Component {
  render() {
    const { title } = this.props;

    return (
      <div className="headerContainer">
        <span className="circulo"/>
        <h1 className="titulo">{title}</h1>
        <span className="linha"></span>
      </div>
    );
  }
}
export default Header;
